import ApiClient from '@bitsbeats/bb-horus-api-client';
const Keycloak = require('./Keycloak');

export default new ApiClient(Keycloak,{
    version: Number(window._ENV.REACT_APP_API_VERSION),
    baseUrl: window._ENV.REACT_APP_API_URL || window.location.origin,
    appendVersionToUrl: window._ENV.REACT_APP_APPEND_TO_URL,
    debug: false,
    tokenUpdateSec: window._ENV.REACT_APP_TOKEN_REFRESH_EVERY,
});